import { render, staticRenderFns } from "./speechInput.vue?vue&type=template&id=cb8675f6&scoped=true"
import script from "./speechInput.vue?vue&type=script&lang=js"
export * from "./speechInput.vue?vue&type=script&lang=js"
import style0 from "./speechInput.vue?vue&type=style&index=0&id=cb8675f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8675f6",
  null
  
)

export default component.exports